"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationProject',
  data: function data() {
    return {
      listLoading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        status: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      statusText: {
        pending_start: '待开工',
        in_progress: '施工中',
        construction_done: '待软装',
        acceptance: '验收中',
        completed: '已竣工'
      },
      statusTag: {
        pending_start: 'warning',
        in_progress: 'success',
        construction_done: '',
        acceptance: '',
        completed: 'success'
      },
      roleText: {
        foreman: '工长',
        designer: '设计师',
        supervisor: '监理',
        coordinator: '协调人'
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _decoration.decorationProjectListApi)(this.searchForm).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        keywords: '',
        status: ''
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    statusCount: function statusCount(status) {
      return this.tableData.data.filter(function (item) {
        return item.project.status === status;
      }).length;
    },
    memberName: function memberName(row, role) {
      var member = (row.members || []).find(function (item) {
        return item.projectRole === role;
      });
      return member ? member.staffName || '--' : '--';
    },
    formatMoney: function formatMoney(value) {
      return Number(value || 0).toFixed(2);
    }
  }
};